import React from 'react';
import Form from './Form';

export default function New(props) {
  return (
    <Form {...props} liveStream={{}} />
  );
}
